import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  width: fit-content;
`

export const PortalsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  max-height: 50vh;
  overflow-y: auto;
`
